import { EditorState, RichUtils } from "draft-js";

export function toggleInlineStyle<T extends string>(editorState: EditorState, inlineStyle: T): EditorState {
    return RichUtils.toggleInlineStyle(
        editorState,
        inlineStyle
    );
}